import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from "../../../layout/default";
import { Button, Col, Form, Row, Container, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Block from "../../../components/Block/Block";

const ConfigSettings = () => {
    const [settings, setSettings] = useState(null); // null indicates loading state
    const [formData, setFormData] = useState({
        referal_incentive: '',
        max_level: '',
        default_vendor_id: '',
        vendor_comission: '',
    });
    const [vendors, setVendors] = useState([]); // Vendors for the dropdown
    const [message, setMessage] = useState('');
    const authToken = localStorage.getItem("authToken");
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    // Fetch vendors for dropdown
    const fetchVendors = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_HOST}api/vendors`,{ headers }
            );
            setVendors(response.data);
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: `Failed to fetch vendors: ${error.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    // Fetch settings
    const fetchSettings = () => {
        Swal.fire({
            title: 'Loading...',
            text: 'Fetching configuration settings...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        axios.get(`${process.env.REACT_APP_HOST}api/config-settings`, { headers })
            .then(response => {
                if (response.data.length > 0) {
                    setSettings(response.data[0]);
                    setFormData(response.data[0]);
                } else {
                    setSettings([]);
                }
                Swal.close();
            })
            .catch(error => {
                setMessage(`Error: ${error.message}`);
                Swal.fire({
                    title: 'Error!',
                    text: `Failed to fetch settings: ${error.message}`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            });
    };

    const createSetting = () => {
        axios.post(`${process.env.REACT_APP_HOST}api/config-settings`, formData, { headers })
            .then(response => {
                setSettings(response.data);
                setMessage('Setting created successfully!');
                Swal.fire({
                    title: 'Success!',
                    text: 'Setting created successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
            })
            .catch(error => setMessage(`Error: ${error.message}`));
    };

    const updateSetting = () => {
        axios.put(`${process.env.REACT_APP_HOST}api/config-settings/${settings.id}`, formData, { headers })
            .then(response => {
                setSettings(response.data);
                setMessage('Setting updated successfully!');
                Swal.fire({
                    title: 'Success!',
                    text: 'Setting updated successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
            })
            .catch(error => {
                setMessage(`Error: ${error.message}`);
                Swal.fire({
                    title: 'Error!',
                    text: `Error: ${error.message}`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (settings && settings.id) {
            updateSetting();
        } else {
            createSetting();
        }
    };

    useEffect(() => {
        fetchSettings();
        fetchVendors(); // Fetch vendors when the component mounts
    }, []);

    if (settings === null) {
        return null; // Don't render anything until the fetch is complete
    }

    return (
        <Layout title="admin-dashboard">
            <Container>
                <h2 className="text-center my-4">Admin Dashboard</h2>
                <Block.HeadContent>
                    <ul className="d-flex">
                        <li>
                            <Link
                                to="/shop/admin/admin-panel"
                                className="btn btn-primary btn-md d-md-none"
                            >
                                <span>Go To Panel</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/shop/admin/admin-panel"
                                className="btn btn-primary d-none d-md-inline-flex"
                            >
                                <span>Go To Panel</span>
                            </Link>
                        </li>
                    </ul>
                </Block.HeadContent>
                {message && <Alert variant="info">{message}</Alert>}

                <div className="mt-4">
                    <h4>{settings.id ? 'Edit Config Setting' : 'Create Config Setting'}</h4>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            {['referal_incentive', 'max_level', 'vendor_comission'].map(field => (
                                <Col sm={12} md={6} key={field}>
                                    <Form.Group controlId={field}>
                                        <Form.Label>{field.replace('_', ' ').toUpperCase()}</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name={field}
                                            value={formData[field] || ''}
                                            onChange={handleInputChange}
                                            required={field !== 'vendor_comission'}
                                        />
                                    </Form.Group>
                                </Col>
                            ))}

                            {/* Vendor Dropdown */}
                            <Col sm={12} md={6}>
                                <Form.Group controlId="default_vendor_id">
                                    <Form.Label>Default Vendor</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="default_vendor_id"
                                        value={formData.default_vendor_id || ''}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Select a vendor</option>
                                        {vendors.map(vendor => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.business_name} ({vendor.first_name} {vendor.last_name})
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="primary" type="submit" className="mt-3">
                            {settings.id ? 'Update' : 'Create'}
                        </Button>
                    </Form>
                </div>
            </Container>
        </Layout>
    );
};

export default ConfigSettings;
